import { API_BASE } from 'shared/constants/Api'
export const NOTIFICATIONS = `${API_BASE}/api/v2/notifications/`
export const NOTIFICATIONS_COLLECTOR_STATUS = `${API_BASE}/api/v2/notifications/invoice_collector_status/`
